<template>
  <div class="grid-container">
    <div class="laptop" ref="laptop">
      <LaptopSvg/>
    </div>
    <div class="introduction">
      <h1 class="title">Hi, I'm Lizette.</h1>
      <h2 class="subtitle">I like to code and draw.</h2>
    </div>
    <div class="portrait">
      <PortraitSvg/>
    </div>
    <div class="tablet" ref="tablet">
      <TabletSvg/>
    </div>
  </div>
</template>

<script>
import PortraitSvg from '../components/PortraitSvg';
import LaptopSvg from '../components/LaptopSvg';
import TabletSvg from '../components/TabletSvg';

export default {
  name: 'IntroSection',
  components: {
    PortraitSvg,
    LaptopSvg,
    TabletSvg,
  },
  mounted: function() {
    const observer = this.createObserver();
    observer.observe(this.$refs["tablet"]);
    observer.observe(this.$refs["laptop"]);
  },
  methods: {
    buildThresholdList: function() {
      const thresholds = [];
      const numSteps = 20;

      for (let i=1.0; i<=numSteps; i++) {
        const ratio = i/numSteps;
        thresholds.push(ratio);
      }

      thresholds.push(0);
      return thresholds;
    },
    createObserver: function() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: this.buildThresholdList()
      };
      const observer = new IntersectionObserver(this.triggerAnimations, options);
      return observer;
    },
    triggerAnimations: function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains("animate")) {
          entry.target.className += " animate";
        }
      });
    }
  }
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-rows: 40% auto;
  grid-template-columns: auto;
  width: 100%;
}

.title {
  font-size: 2.25rem;
  margin: 1rem 0;
}

.subtitle {
  font-size: 1.5rem;
  font-weight: normal;
  margin: 1rem 0;
}

.portrait, .tablet {
  display: none;
}

.laptop {
  grid-row-start: 1;
  grid-row-end: 2;
  grid-column-start: 1;
  grid-column-end: 2;
  align-self: end;
}

.introduction {
  grid-row-start: 2;
  grid-row-end: 3;
  grid-column-start: 1;
  grid-column-end: 2;
  align-self: baseline;
}

@media screen and (min-width: 768px) {
  .grid-container {
    grid-template-rows: auto 400px auto;
    grid-template-columns: auto;
  }

  .laptop, .introduction, .portrait, .tablet {
    display: block;
  }

  .laptop {
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 3;
    grid-column-end: 4;
    align-self: end;
    justify-self: end;
  }

  .introduction {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: span 3;
    align-self: center;
    justify-self: baseline;
  }

  .portrait {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 5;
    grid-column-end: 6;
    justify-self: end;
  }

  .tablet {
    grid-row-start: 3;
    grid-row-end: 4;
    grid-column-start: 1;
    grid-column-end: 2;
    justify-self: end;
  }
}

@media screen and (min-width: 1024px) {
  section {
    padding: 2rem 10%;
    min-width: 1024px;
  }

  .title {
    font-size: 3.5rem;
  }

  .subtitle {
    font-size: 2rem;
  }
}
</style>

